import { buildLoader } from '../../helpers/pageLoader';

document.addEventListener("DOMContentLoaded", () => {
    const links = document.querySelectorAll<HTMLAnchorElement>('nav.local-nav-sidebar a, .small-breadcrumbs a');
    links.forEach(link => {
        link.addEventListener('click', (e) => {
            if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) {
                return; // let the browser handle new-tab/new-window/download
            }
            buildLoader();
        });
    });
});
